<template>
    <div v-bind:style="{height: height}">&nbsp;</div>
</template>

<script>
    export default {
        name: "Spacer",
        props: {
            height: {
                type: String,
                default: '25px'
            }
        }
    }
</script>

<style scoped>

</style>